import { Link } from 'react-router-dom';
import {
  FaArrowRight, FaUsers, FaHandshake,
  FaLightbulb, FaStar, FaGlobe, FaBalanceScale,
} from 'react-icons/fa';

const leadership = [
  { name: 'Anusha Gopu', title: 'President & Founder', years: '15+ yrs in IT Consulting', initials: 'RM', color: 'bg-blue-700' },
  { name: 'Sundar Yeruva', title: 'Chief Technology Officer', years: '20+ yrs in Cloud Architecture', initials: 'PS', color: 'bg-violet-700' },
];

const values = [
  { icon: <FaStar size={20} />, title: 'Technical Excellence', desc: 'We uphold the highest standards in engineering and delivery, ensuring every solution is robust and scalable.' },
  { icon: <FaHandshake size={20} />, title: 'Client First', desc: 'Your success is our success. We listen deeply, align with your goals, and deliver outcomes that matter.' },
  { icon: <FaLightbulb size={20} />, title: 'Innovation', desc: 'We embrace emerging technologies and continuously evolve our practice to keep clients ahead of the curve.' },
  { icon: <FaBalanceScale size={20} />, title: 'Integrity', desc: 'Transparent communication, honest timelines, and ethical business practices underpin everything we do.' },
  { icon: <FaUsers size={20} />, title: 'Diversity & Inclusion', desc: 'Our strength comes from diverse perspectives. We build inclusive teams that reflect the world we serve.' },
  { icon: <FaGlobe size={20} />, title: 'Community Impact', desc: 'We invest in STEM education, workforce development, and technology initiatives in our local communities.' },
];

const milestones = [
  { year: '2022', event: 'MARVY IT Services founded in Boston, MA with a focus on IT staffing' },
  { year: '2024', event: 'Expanded to cloud consulting' },
];

export default function About() {
  return (
    <div className="bg-white">

      {/* Hero */}
      <section className="bg-gradient-to-br from-[#0c1b4d] to-[#1d4ed8] text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
        <div className="relative max-w-7xl mx-auto px-4">
          <span className="text-cyan-400 text-sm font-semibold uppercase tracking-widest">Who We Are</span>
          <h1 className="text-4xl md:text-5xl font-bold mt-2 mb-4">About MARVY IT Services</h1>
          <p className="text-blue-200 max-w-2xl text-lg leading-relaxed">
            For over a decade, we have been the trusted technology partner for organizations navigating digital transformation and IT modernization.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 40" className="w-full fill-white" preserveAspectRatio="none">
            <path d="M0,40 C480,0 960,40 1440,0 L1440,40 Z" />
          </svg>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div className="bg-gradient-to-br from-[#0c1b4d] to-[#1d4ed8] rounded-3xl p-10 text-white">
              <div className="grid grid-cols-2 gap-5">
                {[
                  { value: '15+', label: 'Years of Experience' },
                  { value: '10+', label: 'Clients Served' },
                  { value: '20+', label: 'Projects Completed' },
                ].map((s, i) => (
                  <div key={i} className="bg-white bg-opacity-10 rounded-2xl p-5 text-center">
                    <div className="text-3xl font-extrabold text-cyan-400">{s.value}</div>
                    <div className="text-sm text-blue-200 mt-1">{s.label}</div>
                  </div>
                ))}
              </div>
              <div className="mt-6 bg-white bg-opacity-10 rounded-2xl p-5">
                <p className="text-sm text-blue-200 italic leading-relaxed">
                  "Our mission is simple: connect the right talent with the right opportunity, and deliver technology solutions that create lasting business value."
                </p>
                <p className="text-white text-sm font-semibold mt-3">— Anusha Gopu, President</p>
              </div>
            </div>
            <div>
              <span className="text-cyan-600 text-sm font-semibold uppercase tracking-widest">Our Story</span>
              <h2 className="text-3xl font-bold text-[#0c1b4d] mt-2 mb-5">Built on Expertise, Driven by Results</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                MARVY IT Services was founded in 2022 in Boston, Massachusetts with a simple mission: help organizations harness technology to achieve their strategic goals. What began as a specialized .NET consulting firm has grown into a full-service IT solutions provider serving clients across the United States.
              </p>
              <p className="text-gray-600 leading-relaxed mb-6">
                Today, our consultant network spans cloud architecture, software development, data engineering, cybersecurity, and managed services. We partner with  Financial and Healthcare companies, mid-market enterprises, and government agencies to deliver technology that actually works.
              </p>
{/*               <ul className="space-y-2.5">
                {[
                  'Microsoft Gold Partner & AWS Consulting Partner',
                  'CMMI Level 3 certified delivery processes',
                  'ISO 27001 certified information security practices',
                  'Active presence across 15+ US metropolitan areas',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <FaCheckCircle className="text-cyan-500 mt-0.5 flex-shrink-0" size={15} />
                    <span className="text-gray-600 text-sm">{item}</span>
                  </li>
                ))}
              </ul> */}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-cyan-600 text-sm font-semibold uppercase tracking-widest">What We Stand For</span>
            <h2 className="text-3xl font-bold text-[#0c1b4d] mt-2 mb-3">Our Core Values</h2>
            <p className="text-gray-500 max-w-xl mx-auto">The principles that guide every engagement, every hire, and every decision we make.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((v, i) => (
              <div key={i} className="bg-white p-6 rounded-2xl border border-gray-100 hover:shadow-md transition-shadow">
                <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600 mb-4">
                  {v.icon}
                </div>
                <h3 className="font-semibold text-[#0c1b4d] mb-2">{v.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-cyan-600 text-sm font-semibold uppercase tracking-widest">Our People</span>
            <h2 className="text-3xl font-bold text-[#0c1b4d] mt-2 mb-3">Leadership Team</h2>
            <p className="text-gray-500 max-w-xl mx-auto">Experienced leaders who have built and scaled technology organizations across industries.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {leadership.map((m, i) => (
              <div key={i} className="text-center p-6 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow">
                <div className={`w-20 h-20 ${m.color} rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4`}>
                  {m.initials}
                </div>
                <h3 className="font-semibold text-[#0c1b4d] text-base">{m.name}</h3>
                <p className="text-blue-600 text-sm mt-0.5">{m.title}</p>
                <p className="text-gray-400 text-xs mt-1.5">{m.years}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-[#0c1b4d] text-white">
        <div className="max-w-3xl mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-cyan-400 text-sm font-semibold uppercase tracking-widest">Our Journey</span>
            <h2 className="text-3xl font-bold mt-2">Company Milestones</h2>
          </div>
          <div className="relative border-l-2 border-white border-opacity-20 pl-8 space-y-8">
            {milestones.map((m, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-10 top-1 w-4 h-4 bg-cyan-500 rounded-full border-4 border-[#0c1b4d]" />
                <div className="bg-white bg-opacity-5 border border-white border-opacity-10 rounded-xl p-4">
                  <span className="text-cyan-400 font-bold text-sm">{m.year}</span>
                  <p className="text-blue-100 text-sm mt-1">{m.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-[#0c1b4d] mb-3">Ready to work with us?</h2>
          <p className="text-gray-500 mb-6">Whether you need a single consultant or a full delivery team, we're ready to help.</p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 bg-[#0c1b4d] text-white font-semibold rounded-xl hover:bg-blue-900 transition-colors">
              Contact Us <FaArrowRight size={13} />
            </Link>
            <Link to="/careers" className="inline-flex items-center gap-2 px-6 py-3 border border-[#0c1b4d] text-[#0c1b4d] font-semibold rounded-xl hover:bg-slate-50 transition-colors">
              View Open Roles
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
